import React, { useState, useEffect } from 'react'
import MenuDeMuestrasInput from './MenuDeMuestrasInput'
import { actualizarDatosParaMuiTable } from './tablaMenuMuestras/actions/MenuDeMuestrasTablaActions'
import { connect } from 'react-redux'
import NumeroDeLoteInput from './NumeroDeLoteInput'
import MenuDeMuestrasInputCDP from './MenuDeMuestrasInputCDP'
import { Button } from '@material-ui/core'
import { llamadoMenuMuestras, getDatoDeMuestraConCDP } from '../../../models/calado/menu_muestras_llamados'
import { toast, ToastContainer } from 'react-toastify'
import { closeDialog, openDialog } from '../../Forms/SharedComponents/containers/Dialog/actions/dialogActions'

const MenuDeMuestras = (props) => {
  // estado en memoria
  const [numeroLote, setNumeroLote] = useState('')
  const [numeroDeMuestra, setNumeroDeMuestra] = useState('')
  const [numeroDeCDP, setNumeroDeMuestraCDP] = useState('')

  // acciones sin memoria
  function guardarDato () {
    if (numeroLote) {
      llamadoMenuMuestras(numeroDeMuestra, numeroLote).then(() => {
        // props.actualizarDatosParaMuiTable()
        toast.success('Ingreso Correcto!', { position: 'bottom-right' })
        setNumeroDeMuestra('')
      }).catch(() => {
        toast.error('Error de ingreso', { position: 'bottom-right' })
      })
    } else {
      toast.error('Ingrese el número de lote!', { position: 'bottom-right' })
    }
  }

  function actualizarNumeroLote (numeroLote) {
    setNumeroLote(numeroLote)
  }

  function guardarNumeroDeMuestra (numeroDeMuestra) {
    setNumeroDeMuestra(numeroDeMuestra)
  }

  function guardarNumeroDeMuestraCDP (numeroDeCDP) {
    setNumeroDeMuestraCDP(numeroDeCDP)
  }

  function guardarDatoCDP () {
    getDatoDeMuestraConCDP(numeroDeCDP).then((muestras) => {
      if (muestras[0].numeroDeMuestra !== null && muestras[0].numeroDeMuestra > 0) {
        llamadoMenuMuestras(`000000${muestras[0].numeroDeMuestra}00`, numeroLote).then(() => {
          // props.actualizarDatosParaMuiTable()
          toast.success('Ingreso Correcto!', { position: 'bottom-right' })
          setNumeroDeMuestraCDP('')
        })
      } else {
        toast.error('No se pudo obtener el número de muestra desde la CPE.')
      }
    }).catch(() => {
      toast.error('Error de ingreso', { position: 'bottom-right' })
    })
  }

  function seleccionarLote () {
    props.openDialog(() => {
      return (
        <>
          <NumeroDeLoteInput setDatosLote={actualizarNumeroLote} />
          <Button
            type=''
            variant='contained'
            color='primary'
            onClick={() => props.closeDialog()}
          >
          Aceptar
          </Button>
        </>
      )
    })
  }

  // ui rendeizar
  useEffect(() => {
    seleccionarLote()
  }, [])

  function botonDobleUsoMuestras () {
    if (numeroDeMuestra !== '') {
      guardarDato()
    } else if (numeroDeCDP !== '') {
      guardarDatoCDP()
    }
  }

  return (
    <>
      <br />
      <MenuDeMuestrasInput setDatos={guardarDato} setNumeroDeMuestra={guardarNumeroDeMuestra} />
      <br />   <br />   <br />
      <MenuDeMuestrasInputCDP setDatos={guardarDatoCDP} setNumeroDeMuestraCDP={guardarNumeroDeMuestraCDP} />
      <br />   <br />   <br />
      <Button
        type='sumbit'
        variant='contained'
        color='primary'
        onClick={botonDobleUsoMuestras}
      >
        Ingresar
      </Button>
      <br />  <br />
      <Button
        type='sumbit'
        variant='contained'
        color='primary'
        onClick={seleccionarLote}
      >
        Cambiar Lote
      </Button>
      <br /> <br /> <br />
      <ToastContainer />
    </>
  )
}
const mapActionsToProps = {
  actualizarDatosParaMuiTable,
  openDialog: openDialog,
  closeDialog: closeDialog
}
const withRedux = connect(null, mapActionsToProps)

export default withRedux(MenuDeMuestras)
